import { StoryblokSeoActionsUnion, StoryblokSeoActionTypes } from './storyblok-seo.actions';
import { StoryblokSeoInitialState } from './storyblok-seo.state';

export function storyblokSeoReducer(state = StoryblokSeoInitialState, action: StoryblokSeoActionsUnion) {
  switch (action.type) {
    case StoryblokSeoActionTypes.LOAD_STORYBLOK_SEO_CONTENT:
      return {
        ...state,
        loading: true,
      };
    case StoryblokSeoActionTypes.LOAD_STORYBLOK_SEO_CONTENT_SUCCESS:
      return {
        ...state,
        storyblokSEOContent: action.payload.storyblokSEOContent,
        loading: false,
      };
    case StoryblokSeoActionTypes.LOAD_STORYBLOK_SEO_CONTENT_FAILURE:
      return {
        ...StoryblokSeoInitialState,
        error: action.payload.error,
        loading: false,
      };
    default:
      return state;
  }
}
